import { useState, useEffect } from 'react';
import BannerSection from '../../Pages/Alumni/Partials/Banner';

const FacultyList = () => {
  const [showAll, setShowAll] = useState(false);
  const initialVisible = 10;

  const faculties = [
    {
      id: 1,
      name: "Sharmila Aristotle Plato",
      aebasId: "78346801",
      regNo: "69161",
      qualifications: "MBBS, MS, PhD",
      department: "ANATOMY",
      designation: "Professor & HOD",
      employment: "Permanent",
      experience: "20 Years 8 Months"
    },
    {
      id: 2,
      name: "Arathi.m.s.",
      aebasId: "83328580",
      regNo: "83783",
      qualifications: "MBBS, MD",
      department: "ANATOMY",
      designation: "Professor",
      employment: "Permanent",
      experience: "16 Years 7 Months"
    },
    {
      id: 3,
      name: "Y. Janani",
      aebasId: "76483662",
      regNo: "83140",
      qualifications: "MBBS, MD",
      department: "ANATOMY",
      designation: "Associate Professor",
      employment: "Permanent",
      experience: "12 Years 7 Months"
    },
    {
      id: 4,
      name: "J Suchetha",
      aebasId: "71029333",
      regNo: "72646",
      qualifications: "MBBS, MD",
      department: "ANATOMY",
      designation: "Assistant Professor",
      employment: "Permanent",
      experience: "4 Years 8 Months"
    },
    {
      id: 5,
      name: "Manjubhashini.m",
      aebasId: "23000411",
      regNo: "NA",
      qualifications: "M.Sc.",
      department: "ANATOMY",
      designation: "Assistant Professor",
      employment: "Permanent",
      experience: "3 Years 4 Months"
    },
    {
      id: 6,
      name: "Bhuvaneswari M",
      aebasId: "83072218",
      regNo: "NA",
      qualifications: "B.Sc.,M.Sc(Anatomy)",
      department: "ANATOMY",
      designation: "Tutor",
      employment: "Permanent",
      experience: "3 Years 8 Months"
    },
    {
      id: 7,
      name: "Aswini.p",
      aebasId: "78695311",
      regNo: "164566",
      qualifications: "MBBS",
      department: "ANATOMY",
      designation: "Tutor",
      employment: "Permanent",
      experience: "1 Year 10 Months"
    },
    {
      id: 8,
      name: "Ayeesha Showkkath",
      aebasId: "41213077",
      regNo: "163381",
      qualifications: "MBBS",
      department: "ANATOMY",
      designation: "Tutor",
      employment: "Permanent",
      experience: "Months"
    },
    {
      id: 9,
      name: "Preethi Devi A",
      aebasId: "71655431",
      regNo: "151736",
      qualifications: "MBBS",
      department: "ANATOMY",
      designation: "Tutor",
      employment: "Permanent",
      experience: "Months"
    },
    {
      id: 10,
      name: "Kirubakaran",
      aebasId: "90951309",
      regNo: "178217",
      qualifications: "MBBS",
      department: "ANATOMY",
      designation: "Tutor",
      employment: "Permanent",
      experience: "Month"
    },
    {
      id: 11,
      name: "Keerthana",
      aebasId: "96480252",
      regNo: "173461",
      qualifications: "MBBS",
      department: "ANATOMY",
      designation: "Tutor",
      employment: "Permanent",
      experience: "Month"
    },
    {
      id: 12,
      name: "Deva Priya",
      aebasId: "58761440",
      regNo: "176905",
      qualifications: "MBBS",
      department: "ANATOMY",
      designation: "Tutor",
      employment: "Permanent",
      experience: "Months"
    },
    {
      id: 13,
      name: "Aswini Periyasamy",
      aebasId: "44599225",
      regNo: "159660",
      qualifications: "MBBS",
      department: "ANATOMY",
      designation: "Tutor",
      employment: "Permanent",
      experience: "Months"
    },
    {
      id: 14,
      name: "Edith Jenifer Ananda Raja",
      aebasId: "36889701",
      regNo: "121118",
      qualifications: "MBBS",
      department: "ANATOMY",
      designation: "Tutor",
      employment: "Permanent",
      experience: "Months"
    },
    {
      id: 15,
      name: "Benita Anne Ruben",
      aebasId: "42916060",
      regNo: "NA",
      qualifications: "M.Sc(Human Anatomy)",
      department: "ANATOMY",
      designation: "Tutor",
      employment: "Permanent",
      experience: "Months"
    },
    {
      id: 16,
      name: "J Jerushia Judith",
      aebasId: "18851293",
      regNo: "177343",
      qualifications: "MBBS",
      department: "ANATOMY",
      designation: "Tutor",
      employment: "Permanent",
      experience: "Months"
    },
    {
      id: 17,
      name: "R Sangeetha",
      aebasId: "48442590",
      regNo: "152782",
      qualifications: "MBBS",
      department: "ANATOMY",
      designation: "Tutor",
      employment: "Permanent",
      experience: "Months"
    },
    {
      id: 18,
      name: "Moushmi Ashokkumar",
      aebasId: "89948615",
      regNo: "188911",
      qualifications: "MBBS",
      department: "ANATOMY",
      designation: "Tutor",
      employment: "Permanent",
      experience: "Months"
    },
    {
      id: 19,
      name: "Shamili D",
      aebasId: "85308101",
      regNo: "163327",
      qualifications: "MBBS",
      department: "ANATOMY",
      designation: "Tutor",
      employment: "Permanent",
      experience: "Months"
    },
    {
      id: 20,
      name: "Tamilselvan Sivakumar",
      aebasId: "80476735",
      regNo: "196167",
      qualifications: "MBBS",
      department: "ANATOMY",
      designation: "Tutor",
      employment: "Permanent",
      experience: "Months"
    }
  ];

  const handleToggle = () => {
    setShowAll(!showAll);
  };

  const displayedFaculties = showAll ? faculties : faculties.slice(0, initialVisible);

  return (

    <>


      <BannerSection />
      <section className="pb_80 faculty-list-section">
        <div className="container">
          <div className="row">
            <div className="sec-title text-center pb-3">
              <h2> List of fulltime faculties working in NMC approved medical colleges Chettinad Hospital and Research Institute</h2>
            </div>

            <h5 className="text-center">
              Month and Year of submission of details : August 2025
            </h5>
            <div className="table-responsive py-3">
              <table className="table table-bordered" id="valueAddedTable">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Faculty Name</th>
                    <th>AEBAS Attendance ID</th>
                    <th>Medical Registration No.</th>
                    <th>Professional Qualifications</th>
                    <th>Department</th>
                    <th>Designation</th>
                    <th>Nature of Employment</th>
                    <th>Total Teaching Exp.</th>
                  </tr>
                </thead>
                <tbody>
                  {displayedFaculties.map((faculty) => (
                    <tr key={faculty.id}>
                      <td>{faculty.id}</td>
                      <td>{faculty.name}</td>
                      <td>{faculty.aebasId}</td>
                      <td>{faculty.regNo}</td>
                      <td>{faculty.qualifications}</td>
                      <td>{faculty.department}</td>
                      <td>{faculty.designation}</td>
                      <td>{faculty.employment}</td>
                      <td>{faculty.experience}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="text-center mt-3">
                <button
                  id="readMoreBtn"
                  className="btn btn-about mb-5"
                  onClick={handleToggle}
                >
                  {showAll ? 'Read Less' : 'Read More'}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

    </>

  );
};

export default FacultyList;